module.exports = __webpack_public_path__ + "static/conference-room-47633a9e06bd8508b762a120313f3d5f.jpeg";